// Helper to send form submissions to the secure server-side endpoint.
// The backend uses the HUBSPOT_PRIVATE_APP_TOKEN environment variable; it is never exposed client-side.

export async function submitFormPayload(payload) {
  try {
    const response = await fetch('/api/submit-form', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...payload, sourcePage: window.location?.pathname })
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      return { success: false, ...data };
    }

    return data;
  } catch (error) {
    console.error('submitFormPayload failed', error);
    return { success: false };
  }
}
